var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3135_46407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0011 0H4.62554C2.2441 0 0.313477 1.93055 0.313477 4.31206V27.6878C0.313477 30.0693 2.24402 31.9998 4.62554 31.9998H16.1543L16.1739 20.5648H13.2031C12.817 20.5648 12.5037 20.2526 12.5022 19.8666L12.4879 16.1806C12.4864 15.7924 12.8007 15.4769 13.1889 15.4769H16.1543V11.9153C16.1543 7.78215 18.6786 5.53159 22.3657 5.53159H25.3912C25.7783 5.53159 26.0922 5.84542 26.0922 6.23259V9.34063C26.0922 9.72764 25.7786 10.0414 25.3916 10.0416L23.5349 10.0425C21.5298 10.0425 21.1415 10.9953 21.1415 12.3936V15.477H25.5475C25.9673 15.477 26.293 15.8436 26.2436 16.2605L25.8067 19.9465C25.7649 20.2992 25.4658 20.565 25.1106 20.565H21.1611L21.1415 32H28.0013C30.3827 32 32.3132 30.0695 32.3132 27.688V4.31206C32.3132 1.93055 30.3826 0 28.0011 0Z",
    fill: "#337FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3135_46407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.313477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.ce33de2d4e237fc50174d1838966aaca.svg";
export { ForwardRef as ReactComponent };